import $axios from "../../api";

const state = () => ({
    isLoading: false,
    page: 1,
    orderList: [],
    orderData: null,
    orderSummary: 0,
    isSuccess: false,

    paymentMethodList: [],

    syncSummary: {
        not_sync_dash_store: null,
        not_sync_tier: null,
        not_sync_point: null,
    },
    syncSummaryLoading: false,
    syncSummaryError: null,
});

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    ASSIGN_LIST(state, payload) {
        state.orderList = payload;
    },
    ASSIGN_ORDER_SUMMARY(state, payload) {
        state.orderSummary = payload;
    },
    ASSIGN_VIEW(state, payload) {
        state.orderData = payload;
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    ASSIGN_PAYMENT_METHOD(state, payload) {
        state.paymentMethodList = payload;
    },
    SET_SYNC_SUMMARY_LOADING(state, payload) {
        state.syncSummaryLoading = payload;
    },
    ASSIGN_SYNC_SUMMARY(state, payload) {
        state.syncSummary = payload;
    },
    SET_SYNC_SUMMARY_ERROR(state, payload) {
        state.syncSummaryError = payload;
    },
};

const actions = {
    getList({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(
                    `order/store/list?view=${rootState.Main.view}&page=${
                        state.page
                    }${payload ? payload : ""}`
                )
                .then((res) => {
                    commit("ASSIGN_LIST", res.data.data);
                    commit("ASSIGN_ORDER_SUMMARY", res.data.summary);
                    commit("SET_LOADING", false);
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    getView({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(`order/store/view?docentry=${payload ? payload : ""}`)
                .then((res) => {
                    commit("ASSIGN_VIEW", res.data);
                    commit("SET_LOADING", false);
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    getPaymentMethod({ commit, state, rootState, dispatch }) {
        return new Promise((resolve, reject) => {
            $axios
                .get(`order/store/list-payment-method`)
                .then((res) => {
                    commit("ASSIGN_PAYMENT_METHOD", res.data.data);
                    resolve();
                })
                .catch((error) => {
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                    reject(error);
                });
        });
    },
    syncMemberPoint({ commit, state, rootState, dispatch }, cardCode) {
        return new Promise((resolve, reject) => {
            $axios
                .post(`member-union/tier/sync-member`, { card_code: cardCode })
                .then((res) => {
                    const responseData = res.data;
                    console.log("Response from syncMemberPoint:", responseData);
                    if (responseData.status === "success") {
                        dispatch(
                            "Main/globalSuccessSweetAlert",
                            responseData.message,
                            { root: true }
                        );
                        resolve(res);
                    } else {
                        dispatch(
                            "Main/globalSweetAlert",
                            {
                                status: 400,
                                data: responseData,
                            },
                            {
                                root: true,
                            }
                        );
                        reject(
                            new Error(responseData.message || "Sync failed")
                        );
                    }
                })
                .catch((error) => {
                    console.error("Error in syncMemberPoint:", error);
                    if (
                        error.response &&
                        error.response.data &&
                        error.response.data.status === "success"
                    ) {
                        // PERBAIKAN DI SINI JUGA
                        dispatch("Main/globalSweetAlert", error.response, {
                            root: true,
                        });
                        resolve(error.response);
                    } else {
                        dispatch("Main/globalSweetAlert", error.response, {
                            root: true,
                        });
                        reject(error);
                    }
                });
        });
    },
    getSyncSummary({ commit, dispatch }, { refresh = false, silent = false } = {}) {
        commit("SET_SYNC_SUMMARY_LOADING", true);
        commit("SET_SYNC_SUMMARY_ERROR", null);
        const params = refresh ? { refresh: 1 } : {};
        return new Promise((resolve, reject) => {
            $axios
                .get(`order/store/sync-summary`, { params, timeout: 20000 })
                .then((res) => {
                    commit("ASSIGN_SYNC_SUMMARY", res.data.data);
                    commit("SET_SYNC_SUMMARY_LOADING", false);
                    resolve(res.data.data);
                })
                .catch((error) => {
                    commit("SET_SYNC_SUMMARY_LOADING", false);
                    const message =
                        error.code === "ECONNABORTED"
                            ? "Request timeout saat memuat sync summary."
                            : error.response?.data?.message ||
                              "Gagal memuat sync summary.";
                    commit("SET_SYNC_SUMMARY_ERROR", message);
                    if (!silent && error.response) {
                        dispatch("Main/globalSweetAlert", error.response, {
                            root: true,
                        });
                    }
                    reject(error);
                });
        });
    },
    getPointDetail({ commit, state, rootState, dispatch }, { docnum, storeCode }) {
        return new Promise((resolve, reject) => {
            $axios
                .post(`order/store/sync-detail-point`, { docnum, store: storeCode })
                .then((res) => {
                    console.log("Response from getPointDetail:", res.data);
                    resolve(res.data.data);
                })
                .catch((error) => {
                    console.error("Error in getPointDetail:", error);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                    reject(error);
                });
        });
    },
    syncOrderDashboard({ dispatch }, { docnum, storeCode }) {
        return new Promise((resolve, reject) => {
            $axios
                .post(`order/store/sync-dashboard`, { docnum, store: storeCode })
                .then((res) => {
                    const responseData = res.data;
                    if (responseData.status === "success") {
                        dispatch(
                            "Main/globalSuccessSweetAlert",
                            responseData.message,
                            { root: true }
                        );
                        resolve(res);
                    } else {
                        dispatch(
                            "Main/globalSweetAlert",
                            { status: 400, data: responseData },
                            { root: true }
                        );
                        reject(new Error(responseData.message || "Sync failed"));
                    }
                })
                .catch((error) => {
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                    reject(error);
                });
        });
    },
    syncOrderMemberPoint({ dispatch }, { docnum, storeCode }) {
        return new Promise((resolve, reject) => {
            $axios
                .post(`order/store/sync-member-point`, { docnum, store: storeCode })
                .then((res) => {
                    const responseData = res.data;
                    if (responseData.status === "success") {
                        dispatch(
                            "Main/globalSuccessSweetAlert",
                            responseData.message,
                            { root: true }
                        );
                        resolve(res);
                    } else {
                        dispatch(
                            "Main/globalSweetAlert",
                            { status: 400, data: responseData },
                            { root: true }
                        );
                        reject(new Error(responseData.message || "Sync failed"));
                    }
                })
                .catch((error) => {
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
